
import { useTogglePolicy } from 'apprise-frontend-core/toggle/context'
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { EventSubscriber } from 'apprise-frontend-events/subscriptions'
import { useIsFeatureEnabledForBetaTester } from 'apprise-frontend-iam/settings'
import { useTagModules } from 'apprise-frontend-tags/tag/modules'
import { tagModule } from './constants'
import { useUserChangeListener } from './events'
import { UserProps } from './users'



export const UserInitialiser = (props: UserProps) => {

    const { children } = props

    const tagModules = useTagModules()

    const changeListener = useUserChangeListener()             

    const toggles = useTogglePolicy()
    
    const activate = async () => {

        // register as a tagged type.
        tagModules.register(tagModule)

        toggles.set(s => s.given = useIsFeatureEnabledForBetaTester)
    }

    const { content } = useRenderGuard({

        render: <EventSubscriber name='user-change-listener' subscriptions={[changeListener]} >
            {children}
        </EventSubscriber>,
        
        orRun: activate
    })

    return content
}


